import { PathWithId } from "@constellation-academy/epic-ui";

export class VideoSourcesPaths extends PathWithId<typeof VideoSourcesPaths> {
	static readonly pathKey = "videoSources";
	static readonly idKey = "videoSourceId";
}
